import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

// Lazy-loaded route component
const LazySetupRoute = lazy(() => retry(() => import('app/pages/admin/Setup')));

// Component wrapper type
type ComponentProps = Record<string, unknown>;

// Export component wrapper
export const Setup = (props: ComponentProps) => <LazySetupRoute {...props} />;
